import type { StyleRule } from '@archipro-design/aria';
import {
    archizeenTileClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const Page: StyleRule = ({ theme }) => ({
    width: '100%',
    color: theme.siteVariables.bodyColor,
    background: theme.siteVariables.bodyBackground,
});

export const PageContent: StyleRule = ({ theme }) => ({
    width: '100%',
    color: theme.siteVariables.bodyColor,
    background: theme.siteVariables.bodyBackground,
});

export const Container: StyleRule = () => ({
    maxWidth: `1920px`, // page wrap at 1920
    width: '100%',
    margin: `0 auto`,
});

export const Sections: StyleRule = ({ theme }) => ({
    gridGap: pxToRem(55),
    paddingBottom: pxToRem(64),

    [theme.screen.laptop]: {
        gridGap: pxToRem(120),
        paddingBottom: pxToRem(160),
    },
});

export const NarrowContent: StyleRule = () => ({
    maxWidth: pxToRem(1420),
    margin: `0 auto`,
    width: '100%',
});

export const VideoContent: StyleRule = ({ theme }) => ({
    maxWidth: pxToRem(1920),
    padding: pxArrayToRem([0, 50]),
    margin: 0,
    width: '100%',
    [theme.screen.laptop]: {
        [`& .${archizeenTileClassName}`]: {
            width: '100%',
        },
    },
});
